import useDataById from '../core/useDataById';
import { Product } from '../../types/Product';
import { productService } from '../../services/productService';

export  function useProduct({ id }: { id: string }) {
    const {
        data: product,
        loading,
        error,
        deleteItem,
        updateItem,
        
    } = useDataById<Product>({ service: {
        ...productService,
        ...productService.baseService
    }, id });

    return {
     product,
     error,
     loading,
     deleteProduct: deleteItem,
     updateProduct: updateItem,
    }


    
}
